import { render } from "./QuestionGdprScreen.vue?vue&type=template&id=3f351369&scoped=true&lang=html"
import script from "./QuestionGdprScreen.vue?vue&type=script&lang=js"
export * from "./QuestionGdprScreen.vue?vue&type=script&lang=js"

import "./QuestionGdprScreen.vue?vue&type=style&index=0&id=3f351369&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/clawmachine_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f351369"]])

export default __exports__